// 2P AI — pastiglia di stato sessione (§5). Mappa gli stati reali (schema session_status) sulle
// cinque pastiglie. Colori assoluti (stabili tra i temi), definiti in system.css.
const MAP: Record<string, { cls: string; label: string }> = {
  running: { cls: 'run', label: 'In corso' },
  awaiting_approval: { cls: 'wait', label: 'Attende OK' },
  done: { cls: 'done', label: 'Completata' },
  error: { cls: 'err', label: 'Errore' },
  timeout: { cls: 'err', label: 'Errore' },
  queued: { cls: 'rest', label: 'A riposo' },
  paused: { cls: 'rest', label: 'A riposo' },
  canceled: { cls: 'rest', label: 'A riposo' },
};

export function StatusPill({ status }: { status: string }) {
  const m = MAP[status] ?? { cls: 'rest', label: status };
  return <span className={`st ${m.cls}`}>{m.label}</span>;
}
